"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateProvider = void 0;
var state_manager_1 = require("@idp/state-manager");
var event_bus_1 = require("@idp/event-bus");
var localdatastore_1 = require("./localdatastore");
var StateProvider = /** @class */ (function () {
    function StateProvider() {
    }
    StateProvider.getStateManagerInstance = function () {
        if (StateProvider.stateManagerInstance) {
            return StateProvider.stateManagerInstance;
        }
        state_manager_1.StateManager.setup(new state_manager_1.SessionDataStore(), event_bus_1.ICCEventBusManager.getInstance());
        StateProvider.stateManagerInstance = state_manager_1.StateManager.buildStateProxyForNamespace(localdatastore_1.getNamespace('LOGINUI'));
        return StateProvider.stateManagerInstance;
    };
    return StateProvider;
}());
exports.StateProvider = StateProvider;
//# sourceMappingURL=StateProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/api/StateProvider.js
// module id = 85
// module chunks = 8